import { useEffect, useState } from 'react'
import ReactTooltip from 'react-tooltip'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { ViewModalHeader } from './ViewModalHeader'
import { getips, getipstenant } from '../request/request'
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo'

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

export const AddNeighbor = (props: any) => {
    const { currentUser } = useAuth()
    const tenant = useAppSelector((state) => state.TenantSlice.id)

    // Este ID se usa para el DemoModal y para "setID(undefined)" al finalizar
    const [ID, setID] = useState<ID>(undefined)

    // Tomamos el ID de la instancia que viene del padre, ya seleccionada:
    const deviceID = props.uuid

    // States para crear un nuevo neighbor
    const [Neighbor_id, setNeighborId] = useState('')
    const [Router_Id, setRouter] = useState('')
    const [Local_address, setLocalAddress] = useState('')
    const [Local_as, setLocal_as] = useState('')
    const [Peer_as, setPeerAs] = useState('')
    const [Configuration, setconfiguration] = useState('')
    const [hold_time, setholtime] = useState(3)
    const [password, setpassword] = useState('')
    const [descriptionAdd, setDescriptionAdd] = useState('')
    const [selectedValues, setSelectedValues] = useState<string[]>([])
    const [addPath, setAddPath] = useState<number>(0) // 0: disabled, 1: send, 2: receive, 3: send/receive
    const [ip, setips] = useState<any[]>([])
    const [loadingIps, setLoadingIps] = useState(false)
    const [loading, setLoading] = useState(false)

    // Add tab state and routing table state at the top of the component
    const [activeTab, setActiveTab] = useState<'general' | 'ipv4'>('general')
    const [routingTableInput, setRoutingTableInput] = useState('')
    const [routingTables, setRoutingTables] = useState<{ id: string; persist: boolean }[]>([])

    // Add-Path options mapping
    const addPathOptions = [
        { value: 0, label: 'Disabled' },
        { value: 1, label: 'Send' },
        { value: 2, label: 'Receive' },
        { value: 3, label: 'Send/Receive' }
    ]

    // Add handler for adding a routing table
    const handleAddRoutingTable = () => {
        const trimmed = routingTableInput.trim()
        if (trimmed && !routingTables.some(rt => rt.id === trimmed)) {
            setRoutingTables([...routingTables, { id: trimmed, persist: true }])
            setRoutingTableInput('')
        }
    }
    // Handler for toggling persist
    const handleTogglePersist = (id: string) => {
        setRoutingTables(routingTables.map(rt => rt.id === id ? { ...rt, persist: !rt.persist } : rt))
    }
    // Handler for removing a routing table
    const handleRemoveRoutingTable = (id: string) => {
        setRoutingTables(routingTables.filter(rt => rt.id !== id))
    }
    // Allow Enter key to add routing table
    const handleRoutingTableInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            handleAddRoutingTable()
        }
    }

    // Minimally reset form fields after creation
    const resetForm = () => {
        setNeighborId('')
        setRouter('')
        setLocalAddress('')
        setLocal_as('')
        setPeerAs('')
        setSelectedValues([])
        setpassword('')
        setDescriptionAdd('')
        setAddPath(0)
    }

    // Para simular el modal open en el body
    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    // Cada vez que cambie deviceID, cargamos las IPs de esa instancia
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (deviceID) {
                    setLoadingIps(true)
                    if (tenant === 0) {
                        const UserResponse = await getips(deviceID)
                        setips(UserResponse.data)
                    } else {
                        const UserResponse = await getipstenant(deviceID, tenant)
                        setips(UserResponse.data)
                    }
                    setLoadingIps(false)
                } else {
                    setips([])
                }
            } catch (error) {
                console.error('Error loading IP list for create', error)
                setLoadingIps(false)
            }
        }
        fetchData()
    }, [deviceID, tenant])

    // Manejo del checkbox en "Add BGP Families"
    const checeds = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = event.target
        setSelectedValues((prevValues) => {
            const newValues = checked
                ? [...prevValues, value]
                : prevValues.filter((item) => item !== value)
            return newValues
        })
    }

    // Submit para CREAR un nuevo neighbor
    const handleSubmit = async (e: any) => {
        e.preventDefault()
        setLoading(true)

        try {
            // Validation checks using mapping
            const validations = [
                { condition: !deviceID, title: 'Please Select CTX-R Name' },
                { condition: !Neighbor_id || Neighbor_id.trim() === '', title: 'Please fill  Neighbor IP' },
                { condition: !Router_Id || Router_Id.trim() === '', title: 'Please fill Router ID' },
                { condition: !Local_address || Local_address.trim() === '', title: 'Please fill Local Address' },
                { condition: !Local_as || Local_as.trim() === '', title: 'Please fill Local AS' },
                { condition: !Peer_as || Peer_as.trim() === '', title: 'Please fill Peer AS' },
                { condition: selectedValues.length === 0, title: 'Please select at least one BGP family' },
                { 
                    condition: Neighbor_id === Router_Id, 
                    title: 'Validation Error',
                    text: 'Neighbor IP and Router ID cannot have the same value'
                }
            ]

            const failedValidation = validations.find(validation => validation.condition)
            if (failedValidation) {
                setLoading(false)
                Swal.fire({ 
                    icon: 'error', 
                    title: failedValidation.title,
                    text: failedValidation.text || ''
                })
                return
            }

            const body = {
                ipid: Neighbor_id,
                router_id: Router_Id,
                local_address: Local_address,
                local_as: Number(Local_as),
                peer_as: Number(Peer_as),
                typeConfig: Number(Configuration),
                bgpfamily: selectedValues,
                holdtime: hold_time,
                bgppassword: password,
                description: descriptionAdd || null,
                addPath: addPath,
                routingTables: routingTables.map(rt => ({
                    routing_table: rt.id,
                    persist: rt.persist,
                })),
            }

            console.log('AddNeighbor - Payload being sent to backend:', JSON.stringify(body, null, 2))
            console.log('AddNeighbor - Tenant ID:', tenant)
            console.log('AddNeighbor - Device ID:', deviceID)

            if (tenant === 0) {
                await axios
                    .post(API_URL + '/v1/ctxr/configbgpneighbor/' + deviceID, body)
                    .then((res) => {
                        // Backend validation errors using mapping
                        const backendValidations = [
                            { 
                                condition: res.data.error === 'ipid is not ip valid', 
                                title: 'The neighbors IP address is not valid'
                            },
                            { 
                                condition: res.data.error === 'router_id is not ip valid', 
                                title: 'The router ID IP address is not valid.'
                            },
                            { 
                                condition: res.data.error === 'local_address is not ip valid', 
                                title: 'The local address IP is not valid.'
                            }
                        ]

                        const failedBackendValidation = backendValidations.find(validation => validation.condition)
                        if (failedBackendValidation) {
                            Swal.fire({
                                position: 'center',
                                icon: 'error',
                                title: failedBackendValidation.title,
                                showConfirmButton: false,
                                timer: 1500,
                            })
                            setLoading(false)
                        } else {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Your Neighbor has created',
                                showConfirmButton: false,
                                timer: 1500,
                            })
                            props.setID(undefined)
                            props.device(deviceID)

                            axios.get(API_URL + '/v1/ctxr/listconfigbgpneighbor/' + deviceID).then((res) => {
                                props.setRecords(res.data)
                            })
                            resetForm()
                            setTimeout(() => {
                                setLoading(false)
                            }, 1500)
                        }
                    })
                    .catch(() => {
                        setLoading(false)
                    })
            } else {
                await axios
                    .post(API_URL + '/v1/ctxr/configbgpneighbor/' + deviceID + '?tenantId=' + tenant, body)
                    .then((res) => {
                        // Backend validation errors using mapping
                        const backendValidations = [
                            { 
                                condition: res.data.error === 'ipid is not ip valid', 
                                title: 'The neighbors IP address is not valid'
                            },
                            { 
                                condition: res.data.error === 'router_id is not ip valid', 
                                title: 'The router ID IP address is not valid.'
                            },
                            { 
                                condition: res.data.error === 'local_address is not ip valid', 
                                title: 'The local address IP is not valid.'
                            }
                        ]

                        const failedBackendValidation = backendValidations.find(validation => validation.condition)
                        if (failedBackendValidation) {
                            Swal.fire({
                                position: 'center',
                                icon: 'error',
                                title: failedBackendValidation.title,
                                showConfirmButton: false,
                                timer: 1500,
                            })
                            setLoading(false)
                        } else {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Your Neighbor has created',
                                showConfirmButton: false,
                                timer: 1500,
                            })
                            props.setID(undefined)
                            props.device(deviceID)

                            axios
                                .get(API_URL + '/v1/ctxr/listconfigbgpneighbor/' + deviceID + '?tenantId=' + tenant)
                                .then((res) => {
                                    props.setRecords(res.data)
                                })
                            resetForm()
                            setTimeout(() => {
                                setLoading(false)
                            }, 1500)
                        }
                    })
                    .catch(() => {
                        setLoading(false)
                    })
            }
        } catch (error: any) {
            console.log(error)
            setLoading(false)
        }
    }

    // Add handler to save routing tables to new endpoint
    // Remove handleSaveRoutingTables and update the Save button in the IPv4 Unicast Inbound tab to call setActiveTab('general') or close the modal as before.

    // Helper to check if IPv4 or IPv6 Unicast is selected
    const isAdvancedTabSelected = selectedValues.includes('ipv4 unicast') || selectedValues.includes('ipv6 unicast')

    const RTB_REGEX = /^rtb-[a-zA-Z0-9]+$/i;

    return (
        <>
            <div className="modal fade show d-block" role="dialog" tabIndex={-1} aria-modal="true">
                <div className="modal-dialog modal-dialog-centered mw-650px">
                    <div className="modal-content">
                        <ViewModalHeader setID={props.setID} />
                        <div className="modal-body scroll-y mx-5">
                            {/* Tab Navigation: only show if IPv4 or IPv6 Unicast is selected */}
                            {isAdvancedTabSelected && (
                                <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: 24 }}>
                                    <button
                                        type="button"
                                        className={`btn f-parrafo ${activeTab === 'general' ? 'btn-light-marino' : 'btn-light'}`}
                                        style={{ borderRadius: '8px 8px 0 0', marginRight: 8, fontWeight: 600, border: 'none', borderBottom: activeTab === 'general' ? '2px solid #FF4089' : 'none' }}
                                        onClick={() => setActiveTab('general')}
                                    >
                                        General
                                    </button>
                                    <button
                                        type="button"
                                        className={`btn f-parrafo ${activeTab === 'ipv4' ? 'btn-light-marino' : 'btn-light'}`}
                                        style={{ borderRadius: '8px 8px 0 0', fontWeight: 600, border: 'none', borderBottom: activeTab === 'ipv4' ? '2px solid #FF4089' : 'none' }}
                                        onClick={() => setActiveTab('ipv4')}
                                    >
                                        IPv4 Unicast Inbound
                                    </button>
                                </div>
                            )}
                            {/* Tab Content */}
                            {(!isAdvancedTabSelected || activeTab === 'general') && (
                                <form className="form w-100" onSubmit={e => { e.preventDefault(); if (!isAdvancedTabSelected) handleSubmit(e); }}>
                                    <div className="text-center mb-5">
                                        <h1 className="text-marino fw-bolder mb-3 f-titulo fs-md">
                                            Add BGP Neighbor
                                        </h1>
                                    </div>

                                    {/* Bloque centrado para el 'Selected CTX-R Instance' */}
                                    <div className="d-flex flex-column flex-row-auto text-center mb-4">
                                        <label className="form-label f-bold fs-p text-marino required form-label">
                                            Selected CTX-R Instance
                                        </label>
                                        <div className="text-marino f-parrafo" style={{ marginTop: '5px' }}>
                                            {props.instanceName}
                                        </div>
                                    </div>

                                    {/* Neighbor IP, Router ID, Local Address */}
                                    <div className="row">
                                        <div className="col">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                Neighbor IP
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                value={Neighbor_id}
                                                onChange={(e: any) => setNeighborId(e.target.value)}
                                            />
                                        </div>
                                        <div className="col">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                Router ID
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                value={Router_Id}
                                                onChange={(e: any) => setRouter(e.target.value)}
                                            />
                                        </div>
                                        <div className="col">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                Local Address
                                            </label>
                                            <select
                                                className="form-select text-center border border-gray-300 f-parrafo"
                                                aria-label="Select example"
                                                onChange={(e) => setLocalAddress(e.target.value)}
                                                disabled={loadingIps}
                                                value={Local_address}
                                            >
                                                {ip?.length === 0 && (
                                                    <option disabled hidden>
                                                        No data
                                                    </option>
                                                )}
                                                <option disabled hidden value="">
                                                    Select a IP
                                                </option>
                                                {ip.map((ips: any, x: any) => (
                                                    <option key={x} value={ips.value}>
                                                        {ips.value}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: '10px' }} />

                                    {/* Local AS, Peer AS, Hold Time */}
                                    <div className="row">
                                        <div className="col">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                Local AS
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                value={Local_as}
                                                onChange={(e: any) => setLocal_as(e.target.value)}
                                            />
                                        </div>
                                        <div className="col">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                Peer AS
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                value={Peer_as}
                                                onChange={(e: any) => setPeerAs(e.target.value)}
                                            />
                                        </div>
                                        <div className="col">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                Hold Time
                                            </label>
                                            <i
                                                className="fas fa-exclamation-circle ms-2 fs-7"
                                                data-tip="The keep-alive period will correspond to one-third of the hold time."
                                                data-for="holdTimeTooltip"
                                            ></i>
                                            <ReactTooltip id="holdTimeTooltip" place="top" effect="solid" />
                                            <input
                                                type="number"
                                                min={3}
                                                max={65535}
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                value={hold_time}
                                                onChange={(e: any) => setholtime(parseInt(e.target.value))}
                                                onInput={(e: React.FormEvent<HTMLInputElement>) => {
                                                    const inputValue = e.currentTarget.value
                                                    const lastChar = inputValue[inputValue.length - 1]
                                                    if (isNaN(parseInt(lastChar, 10))) {
                                                        setholtime(parseInt(inputValue.slice(0, -1)))
                                                    } else {
                                                        setholtime(parseInt(inputValue))
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Description */}
                                    <div className="row mb-4" style={{ marginTop: '20px' }}>
                                        <div className="col">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                Description
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                value={descriptionAdd}
                                                onChange={(e) => setDescriptionAdd(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {/* BGP Families */}
                                    <div className="mb-10" style={{ justifyContent: 'center' }}>
                                        <label className="form-label fw-bolder text-dark fs-6 mb-3 f-parrafo">
                                            BGP Families
                                        </label>
                                        <i
                                            className="fas fa-exclamation-circle ms-2 fs-7"
                                            data-tip="Please select at least one BGP family."
                                            data-for="bgpFamiliesTooltip"
                                        ></i>
                                        <ReactTooltip id="bgpFamiliesTooltip" place="top" effect="solid" />
                                        <div className="form-check form-check-custom form-check-solid mb-2">
                                            <input
                                                className="form-check-input border border-azul"
                                                type="checkbox"
                                                value="ipv4 mpls-vpn"
                                                checked={selectedValues.includes('ipv4 mpls-vpn')}
                                                onChange={checeds}
                                            />
                                            <label className="form-check-label f-parrafo text-marino">
                                                VPNv4
                                            </label>
                                        </div>
                                        <div className="form-check form-check-custom form-check-solid mb-2">
                                            <input
                                                className="form-check-input border border-azul"
                                                type="checkbox"
                                                value="ipv4 unicast"
                                                checked={selectedValues.includes('ipv4 unicast')}
                                                onChange={checeds}
                                            />
                                            <label className="form-check-label f-parrafo text-marino">
                                                IPv4 Unicast
                                            </label>
                                        </div>
                                        <div className="form-check form-check-custom form-check-solid">
                                            <input
                                                className="form-check-input border border-azul"
                                                type="checkbox"
                                                value="ipv6 unicast"
                                                checked={selectedValues.includes('ipv6 unicast')}
                                                onChange={checeds}
                                            />
                                            <label className="form-check-label f-parrafo text-marino">
                                                IPv6 Unicast
                                            </label>
                                        </div>
                                    </div>

                                    {/* Capabilities - Add-Path */}
                                    <div className="mb-10">
                                        <label className="form-label fw-bolder text-dark fs-6 mb-2 f-parrafo">
                                            Capabilities
                                        </label>
                                        <div className="text-muted f-parrafo" style={{ fontSize: '1.1em', marginBottom: 12 }}>
                                            <span className="text-marino fw-bolder">Add-Path</span>
                                        </div>
                                        <div className="d-flex gap-2 flex-wrap">
                                            {addPathOptions.map((option) => (
                                                <button
                                                    key={option.value}
                                                    type="button"
                                                    className={`btn f-parrafo ${addPath === option.value ? 'btn-primary' : 'btn-light'}`}
                                                    style={{
                                                        minWidth: '80px',
                                                        padding: '6px 12px',
                                                        fontWeight: 600,
                                                        border: addPath === option.value ? 'none' : '1px solid #e4e6ef',
                                                        transition: 'none',
                                                        transform: 'none'
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.transform = 'none'}
                                                    onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
                                                    onClick={() => setAddPath(option.value)}
                                                >
                                                    {option.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Botones */}
                                    {currentUser?.is_demo !== true && (
                                        <div className="d-grid mb-10 justify-content-center">
                                            <div className="row">
                                                <div className="col">
                                                    {isAdvancedTabSelected ? (
                                                        <button
                                                            type="button"
                                                            id="kt_sign_in_next"
                                                            className="btn btn-primary"
                                                            style={{
                                                                opacity: loadingIps ? 0.5 : 1,
                                                                pointerEvents: loadingIps ? 'none' : 'auto',
                                                            }}
                                                            disabled={loadingIps}
                                                            onClick={() => setActiveTab('ipv4')}
                                                        >
                                                            Next
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            id="kt_sign_in_submit"
                                                            className="btn btn-primary"
                                                            style={{
                                                                opacity: loadingIps ? 0.5 : 1,
                                                                pointerEvents: loadingIps ? 'none' : 'auto',
                                                            }}
                                                            disabled={loadingIps}
                                                        >
                                                            {!loading && <span className="indicator-label">Save</span>}
                                                            {loading && (
                                                                <span className="indicator-progress" style={{ display: 'block' }}>
                                                                    Please wait...
                                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                                </span>
                                                            )}
                                                        </button>
                                                    )}
                                                </div>
                                                <div className="col">
                                                    <button
                                                        className="btn border border-pink text-pink f-parrafo"
                                                        style={{ width: '200px' }}
                                                        onClick={() => props.setID(undefined)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {currentUser?.is_demo === true && (
                                        <div className="d-flex justify-content-center">
                                            <button onClick={() => setID(null)} type="submit" id="kt_sign_in_submit">
                                                Add
                                            </button>
                                        </div>
                                    )}
                                </form>
                            )}
                            {/* IPv4 Unicast Inbound Tab: only show if advanced tab is selected and activeTab is 'ipv4' */}
                            {isAdvancedTabSelected && activeTab === 'ipv4' && (
                                <div>
                                    <div className="mb-4">
                                        <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                            Routing Table ID
                                        </label>
                                        <div className="text-muted f-parrafo" style={{ fontSize: '0.95em', marginBottom: 8 }}>
                                            Add AWS routing table IDs (e.g., rtb-xxxxxxxxxxxxxxxxx).
                                        </div>
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                placeholder="rtb-..."
                                                value={routingTableInput}
                                                onChange={e => setRoutingTableInput(e.target.value)}
                                                onKeyDown={handleRoutingTableInputKeyDown}
                                                style={{ maxWidth: 300 }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                style={{ minWidth: 80 }}
                                                onClick={handleAddRoutingTable}
                                                disabled={!routingTableInput.trim() || !RTB_REGEX.test(routingTableInput.trim())}
                                            >
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                    {routingTableInput && !RTB_REGEX.test(routingTableInput.trim()) && (
                                        <div className="text-danger" style={{ fontSize: '0.9em' }}>
                                            Routing Table ID must start with "rtb-" and be followed by letters or numbers.
                                        </div>
                                    )}
                                    <div className="mb-4">
                                        <div className="row fw-bold f-parrafo" style={{ borderBottom: '1px solid #eee', paddingBottom: 8, marginBottom: 8 }}>
                                            <div className="col">Routing Table ID</div>
                                            <div className="col-auto">Persist Upon BGP State</div>
                                            <div className="col-auto"></div>
                                        </div>
                                        {routingTables.length === 0 && (
                                            <div className="text-muted f-parrafo" style={{ fontSize: '0.95em' }}>
                                                No routing table IDs added.
                                            </div>
                                        )}
                                        {routingTables.map(rt => (
                                            <div className="row align-items-center mb-2" key={rt.id} style={{ background: '#fafbfc', borderRadius: 6, padding: 8 }}>
                                                <div className="col" style={{ wordBreak: 'break-all' }}>{rt.id}</div>
                                                <div className="col-auto">
                                                    <label className="form-switch">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={rt.persist}
                                                            onChange={() => handleTogglePersist(rt.id)}
                                                        />
                                                        <span className="form-check-label" style={{ marginLeft: 8 }}></span>
                                                    </label>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-light-danger"
                                                        onClick={() => handleRemoveRoutingTable(rt.id)}
                                                        style={{ borderRadius: '50%', width: 32, height: 32, padding: 0 }}
                                                    >
                                                        <span style={{ fontSize: 18, fontWeight: 700 }}>&times;</span>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="d-flex justify-content-end gap-3 mt-4">
                                        <button
                                            className="btn border border-pink text-pink f-parrafo"
                                            style={{ minWidth: 120 }}
                                            onClick={() => props.setID(undefined)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-primary f-parrafo"
                                            style={{ minWidth: 120 }}
                                            onClick={handleSubmit}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>

            {/* DemoModal en caso de que ID sea distinto de undefined */}
            {ID !== undefined && <DemoModal setID={setID} id={ID} />}
        </>
    )
}
